export const mergeArrays = <T extends { id: string }>(
  existing: T[] = [],
  updates: T[],
): T[] => {
  const uniqueUpdates = updates.reduce((acc, update) => {
    acc.set(update.id, update);
    return acc;
  }, new Map<string, T>());

  const updatedExisting = existing.map((item) => {
    const update = uniqueUpdates.get(item.id);
    if (update) {
      uniqueUpdates.delete(item.id);
      return { ...item, ...update };
    }
    return item;
  });

  const newItems = Array.from(uniqueUpdates.values());

  return [...updatedExisting, ...newItems];
};
